export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_19_99',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_19_99_usd',
			EUR: 'simple_workbook_bundle_19_99_eur',
			GBP: 'simple_workbook_bundle_19_99_gbp',
			AUD: 'simple_workbook_bundle_29_99_aud',
			CAD: 'simple_workbook_bundle_29_99_cad',
			DKK: 'simple_workbook_bundle_159_dkk',
			SEK: 'simple_workbook_bundle_199_sek',
			NOK: 'simple_workbook_bundle_199_nok',
			BRL: 'simple_workbook_bundle_99_99_brl',
			MXN: 'simple_workbook_bundle_299_mxn',
			TRY: 'simple_workbook_bundle_699_try',
			ARS: 'simple_workbook_bundle_26690_ars',
			COP: 'simple_workbook_bundle_79990_cop',
			CLP: 'simple_workbook_bundle_18990_clp',
		},
		primer: 'prd_OKICYhwraevR',
	},
	otp: {
		priceMap: {
			USD: 19.99,
			EUR: 19.99,
			GBP: 19.99,
			AUD: 29.99,
			CAD: 29.99,
			DKK: 159,
			SEK: 199,
			NOK: 199,
			BRL: 99.99,
			MXN: 299,
			TRY: 699,
			ARS: 26690,
			COP: 79990,
			CLP: 18990,
		},
	},
}
